var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"xvideo"}},[_c('video',_vm._g({staticClass:"video-js",attrs:{"id":"my-video","width":"630","height":"420","controls":"","src":_vm.video,"type":"video/mp4"},domProps:{"currentTime":this.startframe}},_vm.$listeners))])}
var staticRenderFns = []

export { render, staticRenderFns }